import styled from "@emotion/styled";
import Button from "@mui/material/Button";
import { COLOR_GREY_2 } from "shared/theme/colors";

export const StyledClearButton = styled(Button)`
  text-transform: inherit;
  column-gap: 0.25rem;
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;

  &:hover {
    background-color: ${COLOR_GREY_2};
  }
`;
